import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import QRCodeViewerModal from "../../customer-database/components/QRCodeViewerModal";

const InformationView = ({ customer, onEditClick }) => {
  const [viewingQRCode, setViewingQRCode] = useState(false);

  const formatAadhaar = (aadhaar) => {
    if (!aadhaar) return "—";
    if (aadhaar.length === 12) {
      return aadhaar.replace(/(\d{4})(\d{4})(\d{4})/, "$1-$2-$3");
    }
    return aadhaar;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "—";
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const infoItems = [
    { icon: "User", label: "Full Name", value: customer?.name },
    {
      icon: "Calendar",
      label: "Date of Birth",
      value: formatDate(customer?.dob),
    },
    {
      icon: "CreditCard",
      label: "Aadhaar Number",
      value: formatAadhaar(customer?.aadhaar_number),
    },
    { icon: "Phone", label: "Phone Number", value: customer?.phone_number },
    {
      icon: "MapPin",
      label: "Address",
      value: customer?.address || "—",
      fullWidth: true,
    },
    { icon: "Building", label: "Village", value: customer?.village || "—" },
    { icon: "MapPin", label: "District", value: customer?.district || "—" },
    { icon: "Map", label: "State", value: customer?.state || "—" },
    { icon: "Mail", label: "Pincode", value: customer?.pincode || "—" },
    {
      icon: "MapPin",
      label: "Cluster",
      value: customer?.clusters?.name || "—",
    },
  ];

  if (customer?.latitude && customer?.longitude) {
    infoItems.push({
      icon: "Navigation",
      label: "Location Coordinates",
      value: `${customer.latitude.toFixed(6)}, ${customer.longitude.toFixed(
        6,
      )}`,
    });
  }

  if (customer?.qr_code) {
    infoItems.push({
      icon: "QrCode",
      label: "QR Code",
      value: "Available",
      qrCode: true,
    });
  }

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="User" size={20} className="text-primary" />
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-foreground">
          Customer Information
        </h2>
        {onEditClick && (
          <div className="ml-auto">
            <Button
              variant="outline"
              size="sm"
              iconName="Edit2"
              iconPosition="left"
              onClick={onEditClick}
            >
              Edit Details
            </Button>
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {infoItems.map((item, index) => (
          <div
            key={index}
            className={`flex items-start gap-3 p-4 rounded-lg border border-border bg-muted/30 ${
              item.fullWidth ? "md:col-span-2" : ""
            }`}
          >
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name={item.icon} size={18} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <label className="text-xs text-muted-foreground uppercase tracking-wide mb-1 block">
                {item.label}
              </label>
              {item.qrCode ? (
                <div className="flex items-center gap-2">
                  <span className="text-base font-medium text-foreground">
                    {item.value}
                  </span>
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="QrCode"
                    iconPosition="left"
                    onClick={() => setViewingQRCode(true)}
                  >
                    View QR Code
                  </Button>
                </div>
              ) : item.badge ? (
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-primary/10 text-primary">
                  {item.value}
                </span>
              ) : (
                <p
                  className={`text-base font-medium text-foreground ${
                    item.mono ? "font-mono" : ""
                  }`}
                >
                  {item.value}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* QR Code Viewer Modal */}
      <QRCodeViewerModal
        isOpen={viewingQRCode}
        onClose={() => setViewingQRCode(false)}
        qrCode={customer?.qr_code}
        customer={customer}
        regions={
          customer?.regions
            ? [{ id: customer.region_id, name: customer.regions.name }]
            : []
        }
      />
    </div>
  );
};

export default InformationView;
